import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';
import { timeConverter } from '../../../utils/utils';

type MessageDateProps = {
    createdAt: string;
    index: number;
};

const MessageDate = ({ createdAt, index }: MessageDateProps) => {
    const isFirstIndex: boolean = index === 0;

    // showing date if day changed
    const newDate: string = timeConverter(createdAt, 'date');

    // Check if the condition for rendering is met
    const shouldRenderDate = newDate !== MessageDate.previousDate;
    MessageDate.previousDate = newDate;

    return (
        <>
            {(isFirstIndex || shouldRenderDate) && (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        mb: 2,
                    }}>
                    <Typography
                        sx={{
                            fontSize: 12,
                            backgroundColor: 'background.light',
                            opacity: 0.9,
                            color: 'text.primary',
                            borderRadius: 8,
                            px: 2,
                            py: 0.5,
                        }}>
                        {isFirstIndex ? MessageDate.previousDate : newDate}
                    </Typography>
                </Box>
            )}
        </>
    );
};

// Initialize static property to hold the previous date
MessageDate.previousDate = '';

export default memo(MessageDate);
